import {manualFileUploaded} from "../preview_uploaded_file";

window.Insight = {
    init() {
        this.handleFormReset();
        this.handleClickEvents();
        this.handleImageUpload();
        this.handleDateTimeChanges();
        this.initSummernote();
    },

    handleFormReset() {
        $('#create-insight-modal').on('show.bs.modal', function () {
            $('#create-insight-form').trigger('reset');

            $('#image-reviewer').hide();
            $('#image-uploader').val('');

            const now = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            const localDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
            const localTime = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

            const $publishDate = $('#insight-publish-date');
            const $publishTime = $('#insight-publish-time');

            if ($publishDate.length) $publishDate.val(localDate);
            if ($publishTime.length) $publishTime.val(localTime);

            if ($publishDate.length && $publishTime.length) {
                const local = new Date(`${$publishDate.val()}T${$publishTime.val()}:00`);
                $('#insight_published_at').val(local.toISOString());
            }
        });
    },

    handleImageUpload() {
        $('#image-uploader').change((e) => {
            manualFileUploaded(e, '#image-reviewer');
            $('#image-reviewer').show();
        });
    },

    handleClickEvents() {
        const createInsightButton = document.getElementById('create-insight-btn');
        if (createInsightButton) {
            createInsightButton.addEventListener('click', () => {
                $('#create-insight-modal').modal('show');
            })
        }

        const imageUploadButton = document.getElementById('image-uploader-btn');
        if (imageUploadButton) {
            imageUploadButton.addEventListener('click', () => {
                const logoUploader = document.getElementById('image-uploader');
                logoUploader.click();
            })
        }


        const filterButtons = document.querySelectorAll('.filter-button');
        filterButtons.forEach(function (button) {
            if (button) {
                button.addEventListener('click', () => {
                    filterButtons.forEach(b => b.classList.remove('active'));
                    button.classList.add('active');

                    const value = button.dataset.categoryId;
                    Insight.filterByCategory(value || null);
                });
            }
        });

        const params = new URL(window.location.href).searchParams;
        const selectedId = params.get('category_id');
        const initialButton = selectedId
            ? document.querySelector(`.filter-button[data-category-id="${selectedId}"]`)
            : document.querySelector(`.filter-button[data-category-id=""]`);
        if (initialButton) {
            filterButtons.forEach(b => b.classList.remove('active'));
            initialButton.classList.add('active');
        }

        Insight.handleShowInsightClicks();
    },

    handleDateTimeChanges() {
        $('#insight-publish-date, #insight-publish-time').on('change', function () {

            const publishDate = $('#insight-publish-date').val();
            const publishTime = $('#insight-publish-time').val();
            if (publishDate && publishTime) {
                const local = new Date(`${publishDate}T${publishTime}:00`);
                $('#insight_published_at').val(local.toISOString());
            }
        });

        $('#insight-hide-date, #insight-hide-time').on('change', function () {
            const hideDate = $('#insight-hide-date').val();
            const hideTime = $('#insight-hide-time').val();
            if (hideDate && hideTime) {
                const local = new Date(`${hideDate}T${hideTime}:00`);
                $('#insight_hide_at').val(local.toISOString());
            }
        });
    },

    initSummernote() {
        $('#insight_description').summernote({
            minHeight: 200,
            focus: false,
            airMode: false,
            fontNames: ['Montserrat'],
            fontNamesIgnoreCheck: ['Montserrat'],
            fontSizeUnits: ['pt'],
            dialogsInBody: true,
            dialogsFade: true,
            disableDragAndDrop: false,
            placeholder: '',
            toolbar: [
                ['style', ['bold', 'italic', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['misc', ['undo', 'redo']]
            ],
            popover: {
                air: [
                    ['color', ['color']],
                    ['font', ['bold', 'clear']]
                ]
            },
        })
            .on('summernote.paste', function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                document.execCommand('insertText', false, bufferText);
            })
            .on('summernote.change', function (customEvent, contents, $editable) {
            });
    },

    handleShowInsightClicks() {
        const insightCards = document.querySelectorAll('.insight-card');
        insightCards.forEach(function (card) {
            if (card) {
                card.addEventListener('click', function (e) {
                    const insightId = card.dataset.insightId;
                    Insight.openInsight(insightId);
                })
            }
        });

        const showInsightButtons = document.querySelectorAll('.show-insight-btn');
        showInsightButtons.forEach(function (button) {
            if (button) {
                button.addEventListener('click', () => {
                    const id = button.dataset.insightId;
                    if (id) {
                        Insight.openInsight(id);
                    }
                });
            }
        });
    },

    filterByCategory(category_id) {
        const params = {};
        if (category_id) {
            params.category_id = category_id;
        }

        const container = $('.insights-list');
        $.ajax({
            url: '/insights',
            method: 'GET',
            data: params,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (html) {
                container.html(html);
                Insight.handleShowInsightClicks();

                const url = new URL(window.location.href);
                if (category_id) {
                    url.searchParams.set('category_id', category_id);
                } else {
                    url.searchParams.delete('category_id');
                }
                window.history.replaceState({}, '', url.toString());
            }
        });
    },

    openInsight(insightId) {
        const master = $('.split-screen-main-panel');
        const panel = $('.split-screen-detail-panel');
        $.ajax({
            url: `/insights/${insightId}`,
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (html) {
                panel.html(html);
                master.addClass('split-open');
                panel.addClass('split-open');

                const selectedCard = document.getElementById(`card-${insightId}`);
                master.animate({scrollTop: selectedCard.offsetTop - 10}, 300);
                panel.animate({scrollTop: 0}, 300);

                const insightCards = document.querySelectorAll('.insight-card');
                insightCards.forEach(card => {
                    if (card.id !== `card-${insightId}-body`) {
                        card.style.backgroundColor = '#ffffff';
                    } else {
                        card.style.backgroundColor = '#1542540D';
                    }
                });

                $(`#hide-${insightId}-btn`).on('click', function (e) {
                    Insight.hideInsight(insightId);
                });

                $(`#share-${insightId}-btn`).on('click', function (e) {
                    Insight.openShareModal(insightId);
                });

                $(`#copy-${insightId}-url-btn`).on('click', function (e) {
                    Insight.copyInsightUrl(insightId);
                })

                $(`#share-${insightId}-selected-btn`).on('click', function (e) {
                    Insight.shareInsight(insightId, false);
                })

                $(`#share-${insightId}-full-team-btn`).on('click', function (e) {
                    Insight.shareInsight(insightId, true);
                })

                $(document).on('click', '.close-insight-btn', function (e) {
                    Insight.closeInsightPanel(insightId);
                });

                $('#add-email-btn').click(function () {
                    const container = $('#email-fields-container');
                    const newRow = $('<div class="d-flex mb-2">').appendTo(container);
                    $(`<input type="email" class="form-control form-control-lg share-${insightId}-email" placeholder="Enter email...">`).appendTo(newRow);
                    $(`<button class="btn btn-link text-danger ml-2" onclick="$(this).parent().remove();"><i class="fas fa-trash"></i></button>`).appendTo(newRow);
                });

                $('#share-insight-modal-' + insightId).on('show.bs.modal', function () {
                    $('#share-insight-form-' + insightId).trigger('reset');
                    $('#email-fields-container').empty();
                });
            },
            error: function () {
            }
        });
    },

    closeInsightPanel(insightId) {
        const master = $('.split-screen-main-panel');
        const panel = $('.split-screen-detail-panel');
        master.removeClass('split-open');
        panel.removeClass('split-open');
        panel.empty();
        const insightCard = document.getElementById(`card-${insightId}-body`);
        insightCard.style.backgroundColor = '#ffffff';
    },

    hideInsight(insightId) {
        $.ajax({
            url: `/insights/${insightId}/hide`,
            type: 'PUT',
            success: function () {
                Insight.closeInsightPanel(insightId);
                $(`#card-${insightId}`).hide();
            }
        });
    },

    openShareModal(insightId) {
        $(`#share-insight-modal-${insightId}`).modal('show');
    },

    shareInsight(insightId, fullTeam = false) {
        let emails = [];
        const emailFields = document.querySelectorAll(`.share-${insightId}-email`);
        emailFields.forEach(field => {
            const email = field.value.trim();
            if (email) {
                emails.push(email);
            }
        })

        $.ajax({
            url: `/insights/${insightId}/share`,
            type: 'PUT',
            data: {
                full_team: fullTeam,
                emails: emails
            },
            success: function () {
                $(`#share-insight-modal-${insightId}`).modal('hide');
                window.location.reload();
            },
        });
    },

    copyInsightUrl(insightId) {
        const url = `${window.location.origin}/insights/${insightId}`;
        window.navigator.clipboard.writeText(url);
        $(`#copy-${insightId}-url-btn`).text('Copied!');
        setTimeout(() => {
            $(`#copy-${insightId}-url-btn`).text('Copy URL');
            $(`#share-insight-modal-${insightId}`).modal('hide');
        }, 1000);
    }
}
